/**
 * Utility function to get the correct API URL based on environment
 * @param endpoint - The API endpoint (e.g., '/api/send-contact-email')
 * @returns The complete URL for the API call
 */
export const getApiUrl = (endpoint: string): string => {
  if (process.env.NODE_ENV === 'production') {
    // Production avec app.itmonkeys.fr
    return `https://app.itmonkeys.fr${endpoint}`;
  }
  
  // En développement, utilise localhost ou IP personnalisée
  const serverHost = process.env.REACT_APP_SERVER_HOST || 'localhost';
  const serverPort = process.env.REACT_APP_SERVER_PORT || '1337';
  return `http://${serverHost}:${serverPort}${endpoint}`;
};

/**
 * API endpoints constants
 */
export const API_ENDPOINTS = {
  CONTACT: '/api/send-contact-email',
  NEWSLETTER: '/api/send-email',
  CONFIRM_EMAIL: '/api/confirm-email',
  ARTICLES: '/api/articles'
} as const; 